import { useState, useCallback, FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Moment } from 'moment';
import { DateFilter } from './DateFilter/DateFilter';
import { AnswerQueryInterface, MgState } from '@types';
import { setIsDateFromSaved, setIsDateToSaved } from '@actions/answerActions';
import { setAnswerFiltersPartially } from '@actions/answersPageAction';

interface Props {
  setAnchorEl: (value: null | HTMLElement) => void;
}

export const DateFilterContainer: FC<Props> = ({ setAnchorEl }) => {
  const dispatch = useDispatch();
  const answersFilter = useSelector<MgState, AnswerQueryInterface>(
    ({ answersPage }) => answersPage.filters
  );
  const [selectedDateFrom, setDateFrom] = useState<Moment>(answersFilter.from as unknown as Moment);
  const [selectedDateTo, setDateTo] = useState<Moment>(answersFilter.to as unknown as Moment);

  const handleDateChange = useCallback(
    (value: Moment, type: 'from' | 'to') => {
      if (type === 'from') {
        // TODO: Fix it
        setDateFrom(value?.startOf('day') || null);
        dispatch(setIsDateFromSaved(false));
      } else {
        setDateTo(value?.endOf('day') || null);
        dispatch(setIsDateToSaved(false));
      }
    },
    [selectedDateFrom, selectedDateTo, dispatch]
  );

  const handleClearButtonClick = useCallback(() => {
    setDateFrom(null);
    setDateTo(null);
    dispatch(setAnswerFiltersPartially({ from: null, to: null }));
    dispatch(setIsDateFromSaved(false));
    dispatch(setIsDateToSaved(false));
  }, [answersFilter, dispatch]);

  const handleSaveButtonClick = useCallback(() => {
    // TODO: Fix it
    dispatch(
      setAnswerFiltersPartially({
        from: selectedDateFrom as unknown as Date,
        to: selectedDateTo as unknown as Date,
      })
    );
    dispatch(setIsDateFromSaved(true));
    dispatch(setIsDateToSaved(true));
    setAnchorEl(null);
  }, [answersFilter, selectedDateFrom, selectedDateTo, dispatch]);

  return (
    <DateFilter
      selectedDateFrom={selectedDateFrom}
      selectedDateTo={selectedDateTo}
      handleDateChange={handleDateChange}
      handleClearButtonClick={handleClearButtonClick}
      handleSaveButtonClick={handleSaveButtonClick}
    />
  );
};
